module.exports = __webpack_public_path__ + "static/media/comment-alt-lines.7a270a80.svg";